@if (isLoggedIn && loggedInUser) {
<div class="flex items-center gap-1">
  <black-notification-bell></black-notification-bell>
  <div
    class="daisy-dropdown daisy-dropdown-end relative border-l border-base-300 pl-2"
  >
    <label
      tabindex="0"
      class="flex items-center justify-center gap-2 cursor-pointer hover:bg-base-200 rounded-full p-2 text-base-content transition-colors"
    >
      <div
        class="w-8 h-8 rounded-full bg-primary text-primary-content flex items-center justify-center font-medium overflow-hidden"
      >
        @if (getAvatarUrl(loggedInUser.profile?.personal?.avatar)) {
        <img
          [src]="getAvatarUrl(loggedInUser.profile?.personal?.avatar)"
          alt="User avatar"
          class="w-full h-full object-cover"
        />
        } @else {
        {{ lastName?.charAt(0) }}
        }
      </div>
      <span
        class="text-sm font-medium hidden md:block max-w-[120px] truncate text-center text-base-content"
        >{{ lastName }}</span
      >
      <i class="fa-solid fa-angle-down text-base-content/60 text-xs"></i>
    </label>
    <div
      tabindex="0"
      class="daisy-dropdown-content z-50 daisy-card daisy-card-bordered bg-base-100 text-base-content w-72 p-2 shadow-xl border-base-300 rounded-box absolute right-0 mt-2"
    >
      <div class="p-4 border-b border-base-300">
        <div class="flex items-center justify-center gap-3">
          <div
            class="w-12 h-12 rounded-full bg-primary text-primary-content flex items-center justify-center text-lg font-medium overflow-hidden"
          >
            @if (getAvatarUrl(loggedInUser.profile?.personal?.avatar)) {
            <img
              [src]="getAvatarUrl(loggedInUser.profile?.personal?.avatar)"
              alt="User avatar"
              class="w-full h-full object-cover"
            />
            } @else {
            {{ lastName?.charAt(0) }}
            }
          </div>
          <div class="min-w-0 flex-1 text-center">
            <h3 class="font-medium truncate text-base-content">{{ lastName }}</h3>
            <p class="text-sm text-base-content/60 truncate">
              {{ loggedInUser.username }}
            </p>
          </div>
        </div>
      </div>
      <ul class="daisy-menu daisy-menu-sm">
        <li>
          <a
            routerLink="/dashboard/user"
            fragment="profile"
            class="flex items-center justify-start gap-2 text-base-content hover:bg-base-200 py-2"
          >
            <i class="fa-solid fa-user text-base-content/60"></i>
            Profile
          </a>
        </li>
        <li>
          <button
            type="button"
            (click)="logout()"
            class="flex items-center justify-start gap-2 text-error hover:bg-error/10 py-2 w-full"
          >
            <i class="fa-solid fa-arrow-right-from-bracket"></i>
            Sign out
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
} @else {
<div class="flex items-center justify-center gap-2">
  <a
    routerLink="/auth/login"
    class="daisy-btn daisy-btn-primary daisy-btn-outline daisy-btn-sm"
  >
    <i class="fa-solid fa-user-tie"></i>
    <span>Log in</span>
  </a>
  <a
    routerLink="/auth/register"
    class="daisy-btn daisy-btn-primary daisy-btn-sm"
  >
    <i class="fa-solid fa-user-plus"></i>
    <span>Sign up</span>
  </a>
</div>
}
